// extracted by mini-css-extract-plugin
module.exports = {"rezdyProductCardImage":"providers-rezdy-RezdyProductCard-RezdyProductCardImage-RezdyProductCardImage__rezdyProductCardImage--2TAIN"};